import { endOfShiftReportSchema } from './chunk-6F2RZCND.mjs';
import { inventoryOnHandReportSchema } from './chunk-GLEIEUV5.mjs';
import { itemComboSalesReportSchema } from './chunk-4F6AWED4.mjs';
import { voidReasonsReportSchema } from './chunk-3RZODTRO.mjs';
import { creditBalanceReportSchema } from './chunk-3XUUHYTE.mjs';
import { creditCardBatchReportSchema } from './chunk-XH7AF4U2.mjs';
import { employeeSalesAndTipsReportSchema } from './chunk-P63QUUEL.mjs';
import { salesOverviewReportSchema } from './chunk-CTZXUPKZ.mjs';

// src/helpers/validationSchemas/reports/index.ts
var getReportsValidationSchema = (bucket) => {
  switch (bucket) {
    case "customReports":
      return itemComboSalesReportSchema;
    case "itemComboSalesReports":
      return itemComboSalesReportSchema;
    case "salesOverviewReports":
      return salesOverviewReportSchema;
    case "endOfShiftReports":
      return endOfShiftReportSchema;
    case "creditCardBatchReports":
      return creditCardBatchReportSchema;
    case "employeeSalesAndTipsReports":
      return employeeSalesAndTipsReportSchema;
    case "voidReasonsReports":
      return voidReasonsReportSchema;
    case "inventoryOnHandReports":
      return inventoryOnHandReportSchema;
    case "creditBalancesReports":
      return creditBalanceReportSchema;
  }
};

export { getReportsValidationSchema };
